exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "copy-to-clipboard .clipboard-btn {\n  border-width: 0;\n  background-color: transparent;\n  color: var(--color-dovegray);\n  display: inline-block;\n}\ncopy-to-clipboard .clipboard-btn:hover {\n  background-color: transparent;\n}\ncopy-to-clipboard.copy-to-clipboard-sm .clipboard-btn {\n  margin-bottom: 3px;\n}\n", ""]);

